module.exports = __webpack_public_path__ + "img/AEM2.8fc162b8.png";